// @flow

import { connect } from 'react-redux';
import './possiblematches.scss';
import { titleCase } from '../../utilities/text';
import PossibleMatches from './possiblematches';
import { consumeSearchHistoryItem, updateSearchParam, resetSearchPrams } from '../../services/search';
import { resetWorkTabs } from '../../services/ui';

const mapState = ({ search }) => ({
  backLinkText: (search.searchParamsHistory.length &&
    titleCase(search.searchParamsHistory[0].title)) || 'Home',
  backLinkTo: (search.searchParamsHistory.length && search.searchParamsHistory[0].page) || '/',
  workMatches: search.searchDetails.workMatches || [],
});

const mapDispatch = {
  backLinkOnClick: consumeSearchHistoryItem,
  resetWorkTabs,
  updateSearchParam,
  resetSearchPrams,
};

export default connect(
  mapState,
  mapDispatch,
)(PossibleMatches);
